import { Modal, Button, Typography, Select, Space, Tag, Row, Input, Col, Divider, Table, Image, Tooltip } from "antd";
import { CloseOutlined, LockFilled } from "@ant-design/icons";
import { useState } from "react";
import { showMessage } from "../Utils/message";
import { extractOriginalFileName, getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from "./CommonFun";
import { Button as UploadButton, IconButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AuthService from "../auth/AuthService";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import { reasonOptions } from "./Constants";
const { Text } = Typography;
const { TextArea } = Input;
const Auth = new AuthService();

const LockPickingButton = ({ allRemainingQty, filteredItems, products, selectedRouteDetails, setRouteStatus, routeChange }) => {
    const layoutDispatch = useLoadingDispatch()

    const [modalVisible, setModalVisible] = useState(false);
    const [reasons, setReasons] = useState({});
    const [notes, setNotes] = useState("");

    const [files, setFiles] = useState([]);
    const [currentItemFiles, setCurrentItemFiles] = useState([]);
    const [deletedFiles, setDeletedFiles] = useState([]);
    console.log(filteredItems);

    

    const handleReasonChange = (item_id, value) => {
        setReasons(prev => ({
            ...prev,
            [item_id]: value
        }));
    };

    const submitImage = (e) => {
        handleSubmitImage(e, setFiles, setCurrentItemFiles)
    }



    const handleOk = async () => {
        const missingReasons = filteredItems.filter(item => !reasons[item.item_id]);
        if (missingReasons.length > 0) {
            showMessage("error", "Please select a reason for all items before locking.");
            return;
        }

        if (currentItemFiles?.length < 1) return showMessage('error', 'Add at least one image')
        
        // Convert to array of objects with item_id, item_internal_id, and reason
        const reasonArray = filteredItems.map(item => ({
            item_id: item.item_id,
            item_name: item.item_name,
            product_netsuite_id: item.item_internal_id,
            reason: reasons[item.item_id] || 0,
            quantity_picked: item.picked_quantity,
            quantity: item.total_quantity,
            item_pallet_id: item?.item_pallet_id

        }));
        const routeData = filteredItems[0]?.route?.split("#####");


        const dataToSend = {
            route_status_id: selectedRouteDetails?.id,
            items_arr: reasonArray,
            notes: notes,
            files: currentItemFiles,
            delivery_date: filteredItems[0]?.delivery_date || null,
            route_name: routeData ? routeData[0] : "",
            route_code: routeData ? routeData[1] : "",
        }

        console.log(dataToSend); // send this to backend
        showLoading(layoutDispatch);
        const url = '/route/lock-route-picking';

        try {
            const res = await Auth.fetch(url, {
                method: 'POST',
                body: JSON.stringify(dataToSend),
            });
            if (res?.ack) {
                setRouteStatus(routeStatus => !routeStatus);
                const uploadPromises = []
                if (files.length > 0) {
                    console.log('files upload ', files);

                    files.forEach((f) => {
                        uploadPromises.push(
                            getUploadUrl(f, 'route-picking', selectedRouteDetails?.id)
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                        );
                    });
                }
                await Promise.all(uploadPromises);
                routeChange(selectedRouteDetails?.id)
                setModalVisible(false);



            } else {
                showMessage('error', res?.message);
                hideLoading(layoutDispatch)

            }
        } catch (err) {
            showMessage('error', 'Something went wrong');
            hideLoading(layoutDispatch)

        }
        //  finally {
        //   hideLoading(layoutDispatch)
        // }
    };

    const handleCancel = () => {
        setReasons({}); // reset all reasons
        setModalVisible(false);
    };

    return (
        <>
            <Button
                danger
                icon={<LockFilled />}
                onClick={() => {
                    setModalVisible(true)

                }}
            >
                Lock Picking
            </Button>

            <Modal
                title="Are you sure to lock picking?"
                // centered
                width={'85vw'}
                open={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Lock"
                cancelText="Cancel"
                okButtonProps={{ size: "large" }}
                style={{ top: 40 }}
                cancelButtonProps={{ size: "large" }}
                afterClose={() => {
                    setReasons({});
                    setNotes("");
                    setFiles([]);
                    setCurrentItemFiles([]);
                    setDeletedFiles([]);
                }}
                footer={[
                    <Button key="cancel" size="large" onClick={() => setModalVisible(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="lock"
                        type="primary"
                        danger
                        icon={<LockFilled />}
                        size="large"
                        onClick={handleOk}
                    >
                        Lock
                    </Button>
                ]}
            >
                <Divider style={{ margin: '1px 1px' }} />
                <>
                    <Row style={{ marginTop: '5px' }} gutter={[16, 16]}>
                        <Col xs={24}>
                            <span>
                                Notes:
                            </span>
                            <TextArea
                                value={notes}
                                onChange={(e) => { setNotes(e.target.value) }}
                                placeholder='Notes.'
                                autoSize={{ minRows: 1, maxRows: 6 }}
                           
                            />

                        </Col>
                    </Row>
                    <div style={{ marginBottom: 4 }}>
                        <UploadButton
                            component="label"
                            variant="contained"
                            sx={{ marginTop: "10px" }}
                            startIcon={<CloudUploadIcon />}
                        >
                            Add files
                            <input
                                type="file"
                                hidden
                                multiple
                                capture
                                accept="image/*, video/*"
                                    onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
                                onChange={(e) => {
                                    const myfiles = e.target.files;

                                    if (myfiles.length > 10) {
                                        showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                                        e.target.value = "";
                                    } else {
                                        submitImage(e);
                                    }
                                }}
                            />
                        </UploadButton>
                    </div>
                    <Image.PreviewGroup>
                        {files?.length > 0 &&
                            files
                                .filter(
                                    (item) =>
                                        !files.some((file) => file.name === item)
                                )
                                .map((item) => {
                                    return (
                                        <div
                                            style={{
                                                position: "relative",
                                                marginRight: "10px",
                                                display: "inline-block",
                                            }}
                                        >
                                            <Image
                                                width={150}
                                                height={100}
                                                style={{ padding: "5px", border: "1px solid lightgrey" }}
                                                //   src={imageUrl}
                                                src={URL.createObjectURL(item.file)}

                                            />
                                            <Tooltip title="Delete">
                                                <CloseOutlined
                                                    style={{
                                                        fontSize: "30px",
                                                        position: "absolute",
                                                        right: 5,
                                                        top: 5,
                                                        color: "#c12828",
                                                    }}
                                                    onClick={() => handleDeleteFile(item.name, files, currentItemFiles, setFiles, setCurrentItemFiles)}

                                                />
                                            </Tooltip>
                                        </div>
                                    );
                                })}
                    </Image.PreviewGroup>

                </>
                <div style={{ marginTop: '15px' }}>


                {allRemainingQty > 0 && (
                    <>
                        <Text type="danger">
                            There are still {filteredItems?.length} products with total of {allRemainingQty} quantity remaining to be picked.
                        </Text>
                        <div style={{ maxHeight: 350, overflowY: "auto", paddingRight: 8 }}>

                            <br />
                            <br />
                           
                            <Table
                                size="small"
                                pagination={false}
                                rowKey="item_id"
                                dataSource={filteredItems.map((item, index) => {
                                    const product = products.find(p => p.code === item.item_id);
                                    return {
                                        key: item.item_id,
                                        index: index + 1,
                                        item_id: item.item_id,
                                        productName: product ? product.name : "Unknown",
                                        total_quantity: item.total_quantity,
                                        picked_quantity: item.picked_quantity,
                                    };
                                })}
                                rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}

                                columns={[
                                    {
                                        title: "Sr No.",
                                        dataIndex: "index",
                                        width: 80,
                                        render: (text) => <Text strong>{text}</Text>,
                                    },
                                    {
                                        title: "Item",
                                        render: (_, record) => (
                                            <span >
                                                {record.item_id} - {record.productName}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Quantity",
                                        render: (_, record) => (

                                            <Text strong>{record.total_quantity?.toLocaleString()}</Text>
                                        ),
                                    },
                                    {
                                        title: "Picked",
                                        render: (_, record) => (
                                            <Text strong>{record.picked_quantity?.toLocaleString()}</Text>
                                        ),
                                    },
                                    {
                                        title: "Remaining",
                                        render: (_, record) => (
                                            <Text strong>{record?.total_quantity - record?.picked_quantity}</Text>
                                        ),
                                    },
                                    {
                                        title: "Reason",
                                        dataIndex: "reason",
                                        width: 220,
                                        render: (_, record) => (
                                            <Select
                                                placeholder="Reason"
                                                style={{ width: "100%" }}
                                                options={reasonOptions}
                                                value={reasons[record.item_id] || undefined}
                                                onChange={(val) => handleReasonChange(record.item_id, val)}
                                            />
                                        ),
                                    },
                                ]}
                            />

                        </div>
                    </>
                )
                }
                </div>


            </Modal>
        </>
    );
};

export default LockPickingButton;
